import { render, staticRenderFns } from "./ProjectActions.vue?vue&type=template&id=8864f934&scoped=true"
import script from "./ProjectActions.vue?vue&type=script&lang=js"
export * from "./ProjectActions.vue?vue&type=script&lang=js"
import style0 from "./ProjectActions.vue?vue&type=style&index=0&id=8864f934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8864f934",
  null
  
)

export default component.exports